import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

const getFeatureFlagsState = (state: RootState) => state.featureFlags;

export const selectFeatureFlags = createSelector(
  [getFeatureFlagsState],
  (featureFlagsState) => featureFlagsState.featureFlags,
);

export const getFeatureFlagsStatusSelector = createSelector(
  [getFeatureFlagsState],
  (featureFlags) => featureFlags?.status,
);

export const getTicketOrCaseFeatureFlagEnabledSelector = createSelector(
  [getFeatureFlagsState],
  (featureFlags) => featureFlags?.ticketOrCaseFeatureFlagEnabled,
);
